import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';
import {
  Card,
  CardCol,
  CardRow,
  Utils,
  C,
  H,
  selectServicesKapp,
} from '@kineticdata/bundle-common';
import { I18n } from '@kineticdata/react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { List } from 'immutable';

const FavoritesDropdownComponent = ({
  profile,
  isOpen,
  toggle,
  servicesKapp,
  favorites,
}) => (
  <Dropdown isOpen={isOpen} toggle={toggle} className="favorites-dropdown">
    <DropdownToggle nav role="button" aria-label="Favorites">
      <span className="far fa-fw fa-lg fa-heart" />
    </DropdownToggle>
    <DropdownMenu right className="favorites-dropdown-menu">
      <div className="dropdown-menu__links">
        {favorites.map(form => (
          <DropdownItem
            tag={Card}
            key={form.slug}
            to={`/kapps/${servicesKapp.slug}/forms/${form.slug}`}
            components={{ Link }}
            color="white"
          >
            <CardRow>
              <CardRow type="prepend" className="text-muted">
                <span
                  className={`fa fa-lg fa-${Utils.getIcon(
                    form,
                    H.getDefaultFormIcon(form),
                  )} fa-fw`}
                />
              </CardRow>
              <CardCol>
                <CardRow>
                  <I18n>{form.name}</I18n>
                </CardRow>
              </CardCol>
            </CardRow>
          </DropdownItem>
        ))}
      </div>
      {favorites.size === 0 && (
        <div className="dropdown-menu__content">
          <div className="text-center text-muted">
            <strong>
              <small>
                <I18n>You do not have any favorite services</I18n>
              </small>
            </strong>
          </div>
        </div>
      )}
      {favorites.size > 0 && (
        <DropdownItem
          tag={Link}
          className="dropdown-menu__footer"
          to={`/kapps/${servicesKapp.slug}/favorites`}
        >
          <I18n>View all favorites</I18n>
        </DropdownItem>
      )}
    </DropdownMenu>
  </Dropdown>
);

const mapStateToProps = state => {
  const profile = state.app.profile;
  const servicesKapp = selectServicesKapp(state);
  const forms = (servicesKapp && servicesKapp.forms) || [];
  return {
    profile,
    servicesKapp,
    favorites: List(
      Utils.getProfileAttributeValues(
        profile,
        C.ATTRIBUTE_USER_PROFILE_FAVORITES,
      ),
    )
      .map(slug => forms.find(form => form.slug === slug))
      .filter(Boolean)
      .take(10),
  };
};

export const FavoritesDropdown = compose(
  connect(mapStateToProps),
  withState('isOpen', 'setIsOpen', false),
  withHandlers({
    toggle: props => () => props.setIsOpen(open => !open),
  }),
)(FavoritesDropdownComponent);
